import { render, staticRenderFns } from "./GoodsInfo.vue?vue&type=template&id=6ea7d57e&scoped=true"
import script from "./GoodsInfo.vue?vue&type=script&lang=js"
export * from "./GoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfo.vue?vue&type=style&index=0&id=6ea7d57e&prod&lang=less&scoped=true"
import style1 from "./GoodsInfo.vue?vue&type=style&index=1&id=6ea7d57e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea7d57e",
  null
  
)

export default component.exports